// import { login, logout, getInfo, refreshToken } from '@/api/login'
// import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: '',
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  },

  mutations: {
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    // },
    // SET_EXPIRES_IN: (state, time) => {
    //   state.expires_in = time
    // },
    // SET_NAME: (state, name) => {
    //   state.name = name
    // },
    // SET_AVATAR: (state, avatar) => {
    //   state.avatar = avatar
    // },
    // SET_ROLES: (state, roles) => {
    //   state.roles = roles
    // },
    // SET_PERMISSIONS: (state, permissions) => {
    //   state.permissions = permissions
    // }
  },

  actions: {
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js